// this is an autogenerated file from DesignSystem/TasksCreateForm/Actions/Content/LetterNew/PostalAddress/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_TasksCreateForm_Actions_Content_LetterNew_PostalAddress($person_id: uuid!) {
  vaxiom_contact_method_associations(
    where: {
      person: { _id: { _eq: $person_id } }
      contact_method: { dtype: { _eq: "postal" } }
    }
  ) {
    id
    _id
    postal_address {
      id
      city
      zip
      state
      address_line1
    }
  }
}

`